import React from "react";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import { AiAction, AiActionResult } from "../../store/aiStore";

function describeAction(action: AiAction): string {
  const p = action.params as Record<string, string>;
  switch (action.tool) {
    case "create_list":
      return `Create list "${p.title}"`;
    case "update_list":
      return `Update list "${p.list_name}"`;
    case "delete_list":
      return `Delete list "${p.list_name}"`;
    case "add_place":
      return `Add "${p.place_name}" to "${p.list_name}"`;
    case "remove_place":
      return `Remove "${p.place_name}" from "${p.list_name}"`;
    case "update_place":
      return `Update "${p.place_name}" in "${p.list_name}"`;
    default:
      return action.tool;
  }
}

interface ActionItemProps {
  action: AiAction;
  result?: AiActionResult;
}

export function ActionItem({ action, result }: ActionItemProps) {
  const statusColor =
    result?.status === "success"
      ? "success"
      : result?.status === "error"
        ? "danger"
        : "neutral";

  const statusLabel =
    result?.status === "success"
      ? "✓"
      : result?.status === "error"
        ? "✗"
        : null;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {statusLabel && (
        <Chip size="sm" color={statusColor} variant="soft">
          {statusLabel}
        </Chip>
      )}
      <Typography level="body-sm">{describeAction(action)}</Typography>
      {result?.error && (
        <Typography level="body-xs" color="danger">
          {result.error}
        </Typography>
      )}
    </Stack>
  );
}
